import { Checkbox } from "baseui/checkbox";
import { useSetObjectValue } from "../../hooks/useSetObjectValue";
import { LabelXSmall } from "baseui/typography";
import { Input, SIZE } from "baseui/input";

interface IDictionary {
    [index: string]: any;
}
const celltypes = {
    ///Plants
    "System.Double": NumericCell,
    "System.Int": NumericCell,
    "System.Uint": NumericCell,
    "System.Int32": NumericCell,
    "System.UInt32": NumericCell,
    "System.Enum": NumericCell,
    "System.Byte": NumericCell,
    "System.Boolean": BooleanCell,
    "System.String": StringCell,
    "default": TextCell,
} as IDictionary


export function CellSelector(props: any) {

    if (!props.hasAccessObjectWrite) {
        return <TextCell {...props}></TextCell>
    }
    if (props.type.includes('+')) { // enums
        return <StringCell {...props}></StringCell>
    }
    if (props.type.startsWith('System.Collections')) {
        return <TextCell {...props}></TextCell>
    }
    var tmp = celltypes[props.type || "default"];
    if (tmp === undefined && props.value !== null && Number.parseInt(props.value) !== undefined) {
        tmp = celltypes["System.Int32"];
    }

    const TagName = tmp ?? celltypes["default"];
    return <TagName  {...props} />
}


function StringCell({ objectId, resourceGroupId, name, value }: any) {
    const [value1, setValue, sendValueState, sendNow] = useSetObjectValue(objectId, resourceGroupId, name, value, 3000);

    const onValueChanged = (e: any) => setValue(e.target.value);
    const onBlur = (e: any) => sendNow(e.target.value);

    return (
        <Input size={SIZE.mini}
            value={value1}
            onBlur={onBlur}
            placeholder="..."
            onChange={onValueChanged}
            error={sendValueState.isError}
        />
    );
}


function NumericCell({ objectId, resourceGroupId, name, value }: any) {
    const [value1, setValue, sendValueState, sendNow] = useSetObjectValue(objectId, resourceGroupId, name, value, 3000);

    const onValueChanged = (e: any) => setValue(e.target.value);
    const onBlur = (e: any) => sendNow(e.target.value);

    return (
        <Input size={SIZE.mini}
            value={value1}
            type='number'
            onBlur={onBlur}
            onChange={onValueChanged}
            error={sendValueState.isError}
        />
    );
}

function TextCell({ value }: { value: any }) {
    return (
        <LabelXSmall>{JSON.stringify(value)}</LabelXSmall>
    );
}



function BooleanCell({ objectId, resourceGroupId, name, value }: any) {
    const [value1, setValue, sendValueState] = useSetObjectValue(objectId, resourceGroupId, name, value, 50);
    const onValueChanged = (e: any) => setValue(e.target.checked);
    return (
        <Checkbox error={sendValueState.isError} checked={value1} onChange={onValueChanged}></Checkbox>
    );
}
